<template>
  <div
    class="color-option"
    :style="`background-color:${color}`"
    :class="selected ? 'selected' : ''"
    @click="onClick"
  ></div>
</template>

<script>
export default {
  name: 'ColorOption',
  props: {
    color: {
      type: String,
      required: true,
    },
    selected: Boolean,
  },
  methods: {
    onClick() {
      this.$emit('change', this.color)
    },
  },
}
</script>

<style lang="less" scoped>
.color-option {
  cursor: pointer;
  height: 26px;
  width: 26px;
  border-radius: 50%;
  background-color: blue;
  &.selected {
    outline: 4px solid lightgrey;
  }
}
</style>
